module.exports = __webpack_public_path__ + "static/img/admin_logo_business.ea23d67b.png";